<template>

    <div class="page p-patient_edit">
        <the-dashboard-heading>
            <h2>
                <router-link :to="{ name: 'Patients' }">Pacjenci</router-link>
                <router-link :to="{ name: 'PatientShow', params: { id: patient.id } }">
                    {{ patientName || 'Imię i Nazwisko' }}
                </router-link>
                <span>Edycja</span>
            </h2>
        </the-dashboard-heading>

        <the-dashboard-content>
            <patient-form
                v-model="patient"
                @submit="updatedPatient">
            </patient-form>
        </the-dashboard-content>
    </div>

</template>


<script>

import {mapGetters} from 'vuex'
import store from 'Store'

import TheDashboardHeading from 'Components/Dashboard/TheDashboardHeading'
import TheDashboardContent from 'Components/Dashboard/TheDashboardContent'
import PatientForm from 'Components/Patient/PatientForm'

export default {

    name: 'ViewPatientEdit',

    computed: {
        ...mapGetters(['patient']),
        patientName() {
            let name = this.patient.first_name + ' ' + this.patient.last_name
            return name.trim()
        },
    },

    methods: {
        updatedPatient(after) {
            this.$store.dispatch('PATIENT_UPDATE').then(({data}) => {
                this.$alert.success('Edycja pacjenta', data.message)
                this.$router.push({name: 'PatientShow', params: {id: data.data.id}})
            }).catch((error) => {
                after()
                this.$alert.error('Edycja pacjenta', error.response.data.message)
            })
        }
    },

    beforeRouteEnter(to, from, next) {
        store.dispatch('PAGE_LOADING_SET')
        Promise.all([
            store.dispatch('PATIENT_FETCH', to.params.id)
        ]).then(() => {
            store.dispatch('PAGE_LOADING_RESET')
            next()
        })
    },

    components: {
        TheDashboardHeading,
        TheDashboardContent,
        PatientForm
    }

}

</script>
